import { Requestor } from 'hegyd/core/resources/assets/js/utils/Requestor.js';

export default class SearchBar extends HTMLDivElement {
    constructor() {
        super();

        // La route servant à effectuer la recherche
        this.route = this.dataset.route;

        // Le container où le résultat de la recherche (HTML) sera injecté
        this.jsCadenciesContainer = document.querySelector(`.${this.dataset.target}`);

        // L'element HTML contenant le texte entrée par l'utilisateur
        this.jsCadenciesSearchInput = this.querySelector('.js-cadencies-search-input');

        // Le bouton de déclenchement de la recherche
        this.jsCadenciesSearchBtn = this.querySelector('.js-cadencies-search-btn');
    }

    connectedCallback() {
        this.jsCadenciesSearchBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const value = this.jsCadenciesSearchInput?.value;

            if (value !== undefined && this.jsCadenciesContainer) {
                this.sendAjaxCall(this.route, 'GET', value, (success) => {
                    this.jsCadenciesContainer.innerHTML = success;
                }, (error) => {
                    // eslint-disable-next-line no-console
                    console.log(error);
                });
            }
        });
    }

    // eslint-disable-next-line class-methods-use-this
    sendAjaxCall(route, method, search, callbackSuccess, callbackError) {
        const requestor = new Requestor();
        requestor.sendRequest(route, method, { search }, callbackSuccess, callbackError);
    }
}
